import React, {useRef} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {useReactToPrint} from 'react-to-print';

import {BluePillButton} from '../../common/components/BluePillButton';

const NO_INSTRUCTIONS_HTML = '<p>[ No instructions have been added. ]</p>';

export default function InstructionsPreviewDialog({isOpen, setIsOpen, instructionsHTML = NO_INSTRUCTIONS_HTML}) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle>Instructions</DialogTitle>
      <DialogContent ref={componentRef}>
        <div dangerouslySetInnerHTML={{__html: instructionsHTML}} />
      </DialogContent>
      <DialogActions>
        <Button disabled={instructionsHTML === NO_INSTRUCTIONS_HTML} onClick={handlePrint}>
          Print
        </Button>
        <BluePillButton variant="outlined" onClick={() => setIsOpen(false)} autoFocus>
          OK
        </BluePillButton>
      </DialogActions>
    </Dialog>
  );
}
